"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var spryReactDialogRoot_1 = require("spry-react/DialogPortal/spryReactDialogRoot");
var spryDialogRoot_1 = require("spry-react/DialogPortal/spryDialogRoot");
var DialogRoots = /** @class */ (function (_super) {
    __extends(DialogRoots, _super);
    function DialogRoots() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogRoots.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(spryReactDialogRoot_1.SpryReactDialogRoot, null),
            React.createElement(spryDialogRoot_1.SpryDialogRoot, null)));
    };
    DialogRoots.getSpryReactDialogRootElement = function () {
        var dialogRootNode = document.getElementById(spryReactDialogRoot_1.SpryReactDialogRoot.DialogRootElementId);
        if (!dialogRootNode)
            throw new Error('You must render <DialogRoots> to open spry-react and spry dialogs.');
        return dialogRootNode;
    };
    return DialogRoots;
}(React.PureComponent));
exports.DialogRoots = DialogRoots;
